import { z } from 'zod/v4'

export const WithIdSchema = z.object({ id: z.string() })
export const WithScopeIdSchema = z.object({ scopeId: z.string() })
export const WithSiteIdSchema = z.object({ siteId: z.uuid() })
export const WithHistorySchema = z.object({
  updatedAt: z.coerce.date(),
  updatedBy: z.string(),
})
export const HistorizedScopedModelSchema = WithIdSchema.extend(WithScopeIdSchema.shape).extend(WithHistorySchema.shape)

export type WithId = z.infer<typeof WithIdSchema>
export type WithScopeId = z.infer<typeof WithScopeIdSchema>
export type WithSiteId = z.infer<typeof WithSiteIdSchema>
export type WithHistory = z.infer<typeof WithHistorySchema>
export type HistorizedScopedModel = z.infer<typeof HistorizedScopedModelSchema>

export type HistorizedScopedModelFieldNames = 'id' | 'scopeId' | 'updatedAt' | 'updatedBy'
